module.exports = __webpack_public_path__ + "static/media/shop.c17fc33f.svg";